const dynamicContentMock = {
  contractVersion: "1.0.0",
  uiSchemaVersion: "2026-06",
  lessonSessionId: "lesson-session-va101-2026-0001",
  externalId: "va101-2026-0001",

  theme: {
    studentLevel: "B1",
    paletteKey: "level_b1",
    baseColor: "#00B050",
    opacities: {
      surfaceSubtle: 0.08,
      surfaceStrong: 0.16,
      borderSoft: 0.28,
      accent: 1,
    },
    tokens: {
      pageBackground: "#ECFDF5",
      cardBackground: "#FFFFFF",
      cardBackgroundAlt: "#F8FAFC",
      cardBorder: "#E2E8F0",
      accentText: "#00B050",
      primaryText: "#0F172A",
      inverseText: "#FFFFFF",
    },
  },

  lessonHeaderCard: {
    title: "Cycle 1 VA101",
    subtitle: 'Subject / Object Pronoun & "To Be"',
    badge: "Lingo-AI",
    targetLanguage: {
      code: "en",
      locale: "en-US",
      displayName: "English (US)",
    },
    classMeta: {
      level: "B1",
      topic: "Office Roles & Social Small Talk",
      estimatedDurationMinutes: 50,
    },
  },

  participantsCard: {
    teacher: {
      userId: "teacher-001",
      displayName: "Teacher",
      role: "Virtual Class Instructor",
      avatarUrl: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80",
    },
    students: [
      {
        userId: "student-001",
        displayName: "Student",
        role: "Technical Specialist",
        avatarUrl: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80",
      },
    ],
  },

  pedagogicalContextCard: {
    title: "ESP Reference Sheet",
    sections: [
      {
        sectionId: "to-be-table",
        heading: 'Key Structures (Verb "To Be")',
        contentType: "kv_table",
        rows: [
          { key: "I am", value: "First Person" },
          { key: "You are", value: "Second Person" },
          { key: "He / She is", value: "Third Person" },
          { key: "It is", value: "Neutral (Events/Tools)" },
          { key: "We are", value: "First Plural" },
          { key: "They are", value: "Third Plural" },
        ],
      },
      {
        sectionId: "prepositions",
        heading: "Prepositions of Time",
        contentType: "highlight",
        content: "• ON + Days of the Week (on Monday, on Friday)\n• IN + Months of the Year (in October, in January)",
      },
      {
        sectionId: "hybrid-scope",
        heading: "Hybrid Scope",
        contentType: "paragraph",
        content:
          'Your active milestone goal is "Leading International Meetings" inside "Technology & Software (SaaS)", balanced alongside your interest in "Travel, Culture & Tourism".',
      },
    ],
  },

  navigationState: {
    currentSectionIndex: 0,
    sections: [
      { sectionId: "phase-1", label: "1. Warm-up: Hybrid Org Chart" },
      { sectionId: "phase-2", label: "2. Discovery: Time & Activities" },
      { sectionId: "phase-3", label: "3. Core Task: Business & Chat Sync" },
      { sectionId: "phase-4", label: "4. Cool Down: Media Scene Analyst" },
    ],
  },

  collab: {
    role: "teacher",
    status: "disconnected",
  },

  updatedAt: "2026-06-02T17:30:00Z",
};

export default dynamicContentMock;
